// 9fbef606107a605d69c0edbcd8029e5d
import get from 'lodash/get';
import { connect } from 'react-redux';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import {
  GLOBAL_SMS_SIGN_UP_LABELS,
  GlobalSmsSignUpLabels,
} from '@tcp/core/src/utils/labels/globalSmsSignUp.labels';
import emailSignupAbstractor from '@tcp/core/src/services/abstractors/common/EmailSmsSignup';

import SubscriptionEmailView from '../views';

const splitHeading = (stringVal = '') => {
  const [heading1, heading2] = stringVal.split('##').map((str) => str.trim());
  return {
    heading1,
    heading2,
  };
};

export const mapDispatchToProps = () => {
  return {
    validateSignupEmail: (values) => {
      return emailSignupAbstractor.verifyEmail(values.email);
    },
  };
};

const mapStateToProps = (state) => {
  const submitTitle = renderLabel(
    getLabelFromCopyOrFromTranslation(`${GLOBAL_ACTIONS_LABELS}.lbl_submit`, GlobalActionsLabels),
    'lbl_submit'
  );
  const emailPlaceHolderText = renderLabel(
    getLabelFromCopyOrFromTranslation(
      `${GLOBAL_SMS_SIGN_UP_LABELS}.lbl_combined_email_placeholder`,
      GlobalSmsSignUpLabels
    ),
    'lbl_combined_email_placeholder'
  );
  const validationErrorLabel = getDynamicLabelValues(
    `dynamic.global_d.lbl_email_validationErrorLabel`
  );
  const submissionLabel = getDynamicLabelValues(`dynamic.global_d.lbl_email_submission_message`);

  const titleFullText = getDynamicLabelValues('dynamic.home.lbl_email_subscription');
  const { heading1, heading2 } = splitHeading(titleFullText);

  const richText = get(state, 'Footer.emailSignupBtn.richText.text', '');
  const emailDisclaimer = { richText };

  return {
    heading1,
    heading2,
    submitTitle,
    emailDisclaimer,
    submissionLabel,
    emailPlaceHolderText,
    validationErrorLabel,
  };
};

const SubscriptionEmailContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionEmailView);

export default SubscriptionEmailContainer;
